import { useState, useEffect } from "react";
import platform from "platform";

export const useDeviceInfo = () => {
  const [deviceInfo, setDeviceInfo] = useState<{
    browser: string;
    device: string;
  }>({
    browser: "Unknown",
    device: "Unknown",
  });

  useEffect(() => {
    const browser = platform.name || "Unknown";
    const device =
      platform.os?.family && platform.os?.version
        ? `${platform.os.family} ${platform.os.version}`
        : "Unknown";

    setDeviceInfo({ browser, device });
  }, []);

  return deviceInfo;
};
